import { render } from "./UsersPanel.vue?vue&type=template&id=1fb58089&scoped=true&ts=true"
import script from "./UsersPanel.vue?vue&type=script&lang=ts"
export * from "./UsersPanel.vue?vue&type=script&lang=ts"

import "./UsersPanel.vue?vue&type=style&index=0&id=1fb58089&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb58089"]])

export default __exports__